import { apiClient } from "./client";
import type { EzyVetConnectRequest, EzyVetStatus, EzyVetWebhookCreated } from "@/types";

const BASE = "/api/v1/integrations/ezyvet";

export async function getEzyVetStatus(): Promise<EzyVetStatus> {
  const { data } = await apiClient.get<EzyVetStatus>(BASE);
  return data;
}

/** Validates the credentials with ezyVet, then stores them. Credentials are never returned. */
export async function connectEzyVet(req: EzyVetConnectRequest): Promise<EzyVetStatus> {
  const { data } = await apiClient.put<EzyVetStatus>(BASE, req);
  return data;
}

export async function testEzyVet(): Promise<EzyVetStatus> {
  const { data } = await apiClient.post<EzyVetStatus>(`${BASE}/test`);
  return data;
}

export async function syncEzyVet(): Promise<void> {
  await apiClient.post(`${BASE}/sync`);
}

export async function disconnectEzyVet(): Promise<void> {
  await apiClient.delete(BASE);
}

/** Creates or replaces the clinic's webhook URL and signing secret. The secret is only returned here. */
export async function createEzyVetWebhook(): Promise<EzyVetWebhookCreated> {
  const { data } = await apiClient.post<EzyVetWebhookCreated>(`${BASE}/webhook`);
  return data;
}

export async function deleteEzyVetWebhook(): Promise<void> {
  await apiClient.delete(`${BASE}/webhook`);
}

export async function updateEzyVetSettings(settings: { push_alerts: boolean }): Promise<EzyVetStatus> {
  const { data } = await apiClient.patch<EzyVetStatus>(`${BASE}/settings`, settings);
  return data;
}
